// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/tick.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.todonav {
  font-weight: 600;
  border: none;
  gap: 30px;
  width: auto;
  padding: 2px 30px;
  font-size: 19px;
}
.input-container {
  position: relative;
  display: inline-block;
}
.due-date-input {
  position: relative;
  /* z-index: 2  */
}
#scrollableDiv {
  height: 400px;
  overflow: auto;
}
.modalcontent-width {
  position: relative;
  background-color: white;
  /* padding: 20px 5px 20px 5px !important; */
  padding: 20px;
  height: auto;
  width: 500px;
  border-radius: 10px;
  text-align: center;
  margin: 15% auto;
  border: 1px solid #888;
}

.input-container .form-control {
  padding-right: 30px; /* Adjust the padding to leave space for the icon */
  background: url("https://beta.doneapp.ai/build/assets/date-3aba8fa1.png")
    no-repeat right center;
  background-size: 20px 20px; /* Adjust the size of the icon */
  font-size: 15px;
}
.dateicon {
  position: absolute;
  right: 80px; /* Adjust the position of the icon */
  top: 50%;
  transform: translateY(-50%);
}
.date-width {
  /* width:255px; */
  background-color: #ffff;
  border: solid 1px #dee2e6;
  border-radius: 7px;
}
.dateicon img {
  width: 21px;
}
.custm-radio {
  border-radius: 50% !important;
  background-color: #fff;
  border: 3px solid #009933 !important;
  padding: 10px;
}
.form-check-input:checked {
  border-color: none;
  outline: none;
}
.form-check-input:focus {
  border-color: none;
}
.posticon {
  text-align: justify;
  padding-left: 5px;
  line-height: 20px;
}
.doneheading {
  gap: 5px;
  align-items: start;
}
.tdata {
  overflow: hidden;
  border-top: 0 !important;
  border-right: 0 !important;
  border-left: 0 !important;
}
.createdAt {
  font-size: 10px;
  padding-left: 5px;
  float: left !important;
}
/* button.accordion-button {
  margin-left: 20px;
} */
/* .nav-link.active{
  color:#009933 !important
} */

.taskborder {
  border-bottom: 1px solid #8080807d;
  /* padding: 5px; */
}
.taskborder textarea {
  max-height: 30px;
  resize: none;
  max-width: 70%;
}
.due-colour {
  color: rgba(33, 37, 41, 0.75) !important;
}
.taskborder1 textarea {
  max-height: 100px;
  resize: none;
}
.videpart {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.taskbtn img {
  width: 10px;
  vertical-align: baseline;
  margin-right: 4px;
}
.taskbtn {
  color: #7c7a7acf;
  font-family: Goldplay-bold;
}
a {
  text-decoration: none;
}
.submitclass img {
  width: 35px;
}
.add-input {
  background: none;
  font-size: 14px !important;
}
.videpart input {
  font-size: 18px;
}
.side-bar .menu .item a {
  display: block;
  color: #1a1a1a;
}
.side-bar .menu .item .sub-menu a {
  padding: 3px 0 8px;
}
.inner-accordian {
  padding-top: 15px;
}
.sub-btn {
  color: #1a1a1a;
  gap: 18px;
  justify-content: center;
  align-items: center;
}
.accordian-outer-button {
  color: #1a1a1a !important;
}
.listoption {
  background-color: #f7f7f7;
  padding: 20px 30px;
  border-radius: 12px;
}
.list-group-item {
  background: none !important;
  border: none;
}
.listoption {
  font-weight: bolder;
  color: gray;
  font-size: 19px;
  padding: 10px, 30px;
}
.rightgrey {
  width: 13px;
  vertical-align: initial;
}
.binclass {
  font-size: 17px;
  color: gray;
}
.accordian-text {
  color: gray;
}
.greysearchimg {
  background-color: #f1f1f3;
  border-radius: 26px;
  border-color: transparent;
}
.searchtodo {
  background-color: #f1f1f3;
  border-radius: 20px;
}
.mainpost-acrdn.accordion-button {
  background-color: white !important;
}

.scrollableMain {
  overflow-y: auto;
  height: calc(75vh - 145px);
  overflow-x: hidden;
  /* Customize scrollbar track */
  &::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  /* Customize scrollbar thumb (the draggable handle) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the thumb */
    border-radius: 5px; /* Rounded corners */
  }

  /* Customize scrollbar track when hovered */
  &::-webkit-scrollbar-track:hover {
    background-color: #f0f0f0; /* Change color on hover */
  }

  /* Customize scrollbar thumb when hovered */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Change thumb color on hover */
  }
}

.scrollableMainDone {
  overflow-y: auto;
  height: calc(82vh - 145px);
  &::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  /* Customize scrollbar thumb (the draggable handle) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the thumb */
    border-radius: 5px; /* Rounded corners */
  }

  /* Customize scrollbar track when hovered */
  &::-webkit-scrollbar-track:hover {
    background-color: #f0f0f0; /* Change color on hover */
  }

  /* Customize scrollbar thumb when hovered */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Change thumb color on hover */
  }
}
.scrollableMainDelete {
  overflow-y: auto;
  height: calc(82vh - 145px);
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
  }

  /* Customize scrollbar thumb (the draggable handle) */
  &::-webkit-scrollbar-thumb {
    background-color: #888; /* Color of the thumb */
    border-radius: 5px; /* Rounded corners */
  }

  /* Customize scrollbar track when hovered */
  &::-webkit-scrollbar-track:hover {
    background-color: #f0f0f0; /* Change color on hover */
  }

  /* Customize scrollbar thumb when hovered */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Change thumb color on hover */
  }
}

.edit-input {
  height: 32px;
  font-size: 32px;
}
.edit-input1 {
  height: 32px;
  font-size: 13px;
  width: 50%;
}
.sub-task {
  outline: none;
  width: 100%;
}
.list-style {
  list-style-type: disc;
  padding-left: 5px;
  margin-left: 100px;
}
.custom-file-upload {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.custom-file-input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-gif {
  width: 50px;
  /* Adjust the width of your loading GIF */
  height: 50px;
  /* Adjust the height of your loading GIF */
}
.updated-at {
  font-size: 11px;
  line-height: 12px;
  color: #212529;
}

.text-padding {
  padding: 32px;
}
.main-posts {
  color: rgb(33, 37, 41);
  opacity: 1;
}
.form-check-input:checked[type="radio"] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.form-check-input[type="radio"] {
  border-radius: 50%;
  border: solid 3px #009933;
}
.hidden-popup {
  visibility: hidden;
}

.text-area {
  font-size: 13px;
  color: #212529;
  background-color: #ffff;
  padding: 0.375rem 0.75rem;
  width: 638px !important;
  height: 92px;
  border: solid 2px #dee2e6;
}
.heighttodo {
  height: 45vh;
  overflow-x: hidden;
  position: relative;
}

.accordion-headers {
  background-color: #ffff;
}
.Addtask {
  padding: 10px 10px 5px;
}

.videpart input {
  font-size: 16px;
}
.addtaskpart {
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  padding: 2px 20px 0px;
  position: "fixed";
  top: 0;
  right: 0;
}
.minitodo-checkbox {
  width: 16px;
  height: 16px;
}
.accordian-sort {
  background-color: #ebe2e200;
}
.custm-checkbox:checked {
  background-color: #093 !important;
}
.indexnum {
  width: 4%;
  font-size: 14px;
}
.custm-checkbox {
  width: 24px;
  height: 24px;
  border-radius: 50% !important;
  border: solid 3px #009933 !important;
}
.text-mute {
  vertical-align: middle;
  color: rgb(164 168 174 / 75%) !important;
}
.mainPostFont {
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 400;
}
.font-break {
  word-break: break-all;
}
.upload-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* background-color: #009933; */
  color: #ffff;
  padding: 10px;
  border-radius: 8px;
  /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); */
  width: 20%;
  height: auto;
}
.upload-img-video{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #efefef;
  padding: 0px;
  border-radius: 25px;
  width:12%;
  height: auto;
}
.uploadloader-img{
  width: 100%;
}
.submit-upload{
  width: 44%;
  border-radius: 25%;
}
.upload-popup p {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}
.progress-bar {
  width: 100%;
  height: 10px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.progress {
  background-color: #007bff;
  height: 100%;
  transition: width 0.3s ease;
}
.edit-form textarea {
  height: 28px;
}
.notes {
  position: relative;
  right: 2%;
}
.icons {
  display: flex;
  justify-content: space-between;
}
.custom-infinite {
  overflow: hidden !important;
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal content */
/* .modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  position: relative;
  z-index: 1001;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
} */

/* Reply input */
.modal-header {
  overflow-y: auto; /* Allow vertical scrolling if the content is too long */
}

.modal-title {
  flex: 1 1; /* Allow title to take up the remaining space */
  white-space: normal; /* Allow text wrapping */
  word-wrap: break-word; /* Ensure long words wrap correctly */
  max-height: 100px; /* Optional: Limit title height to prevent it from taking too much space */
  overflow-y: auto; /* Enable vertical scrolling if content exceeds height */
}

.custom-checkbox {
  width: 17px;
  height: 17px;
}

.urgent-post{
  color: red;
}

.red-color{
  color: red;
  font-size: small;
}
.headerModal-text {
  max-width: 400px;
  font-size: 15px;
}
.mainReplyPostFont {
  font-size: 13px;
  padding: 0px !important;
  font-weight: 400;
  color: #003319;
}
.replypadding {
  font-size: 10px;
  padding-left: 38px;
}
.reply-input {
  width: 100%;
  padding: 10px;
  margin-top: 10px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
  box-sizing: border-box;
}

/* Save button */
.save-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.save-button:hover {
  background-color: #218838;
}

/* Close button */
.btn-close {
  /* background: none; */
  border: none;
  font-size: 14px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.text-resize {
  resize: none;
}
.complete {
  text-decoration: line-through;
}
.icons-m{
  width: 100%;
}
.button-icon-main{
  font-size: 17px;
    color: #9b9b9b;
      /* padding-left: 5px; */
}
.mainpost-icons{
  display: flex;
  gap: 8px;
}
.main-imgupload{
  width: 30px;
  height: 23px;
}
@media screen and (max-width: 1024px) {
  .custom-text {
    padding-left: 8px !important;
  }
  .custom-text1 {
    padding-left: 10px !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .icon-padding {
    padding: 0px !important;
  }
  .mainPostFont {
    font-size: 14px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1400px) {
  .icons {
    padding: 0px;
  }
}
@media only screen and (max-width: 600px) {
  .mobile_height {
    height: 90px !important;
    font-size: 12px; /* Set the desired height for mobile screens */
  }
}

@media screen and (max-width: 433px) {
  .nav {
    --bs-nav-link-padding-x: 0;
    font-size: 16px !important;
    padding-bottom: 8px !important;
  }
  .icon-padding {
    padding: 0px;
  }
}
@media screen and (max-width: 576px) {
  .mobile_height {
    height: 42px !important;
  }
  .main-imgupload{
    width: 20px;
    height: 20px;
  }
  .submitclass img {
    width: 25px;
    height: 25px;
  }
.date-mainpost {
font-size: 12px !important;
}
  .button-icon-main{
    font-size: 18px;
      color: #9b9b9b;
      padding-left: 0px;
  }
  .mainpost-icons{
    display: flex;
    gap: 8px;
  }
  .created-duedate{
    text-align: start;
    margin-right: auto;
  }
  .createdAt {
    float: unset !important;
    padding-left: 0px;
  }
  .by-name{
    text-align:start;
  }
  .modalcontent-width {
    padding: 20px 5px 20px 5px !important;
    width: 90%;
  }

  .due-date-input {
    padding: 3px 0px 0px 0px;
  }
  .icons {
    padding: 0px;
    margin-left: 115px;
    justify-content: space-evenly;
    /* margin: auto ; */
  }
  .image-preview-container {
    padding: 0px !important;
  }
  .mainPostFont {
    font-size: 12px;
  }
  .main-postp {
    padding-right: 0px;
  }
  /* .todo-paddingr {
    padding-right: 0px;
  } */
  .todonav {
    gap: 0px !important;
    display: flex;
    /* justify-content: space-between; */
  }
  .nav {
    padding-bottom: 8px !important;
  }
  .sort-hide {
    display: none;
  }
  .scrollableMain,
  .scrollableMainDone,
  .scrollableMainDelete {
    &::-webkit-scrollbar {
      width: 2px;
    }
  }
}
@media screen and (max-width: 768px) {
  .hide-on-small-devices {
    display: none; /* Hide the element for small devices */
  }
}
@media screen and (min-width: 768px) {
  .hide-on-large-devices {
    display: none; /* Hide the element for small devices */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/todos/Mainposts.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,mDAAmD;EACxE;0BACwB;EACxB,0BAA0B,EAAE,gCAAgC;EAC5D,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,oCAAoC;EACjD,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;GAEG;AACH;;GAEG;;AAEH;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B;IACE,WAAW,EAAE,2BAA2B;EAC1C;;EAEA,qDAAqD;EACrD;IACE,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,oBAAoB;EAC1C;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB,EAAE,gCAAgC;EAC1D;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B;IACE,WAAW,EAAE,2BAA2B;EAC1C;;EAEA,qDAAqD;EACrD;IACE,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,oBAAoB;EAC1C;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB,EAAE,gCAAgC;EAC1D;AACF;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB;IACE,WAAW,EAAE,2BAA2B;EAC1C;;EAEA,qDAAqD;EACrD;IACE,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,oBAAoB;EAC1C;;EAEA,2CAA2C;EAC3C;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,2CAA2C;EAC3C;IACE,sBAAsB,EAAE,gCAAgC;EAC1D;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,iEAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,MAAM;EACN,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iDAAiD;EACjD,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kBAAkB;AAClB;;;;;;;;;GASG;;AAEH,gBAAgB;AAChB;EACE,gBAAgB,EAAE,wDAAwD;AAC5E;;AAEA;EACE,SAAO,EAAE,+CAA+C;EACxD,mBAAmB,EAAE,wBAAwB;EAC7C,qBAAqB,EAAE,qCAAqC;EAC5D,iBAAiB,EAAE,0EAA0E;EAC7F,gBAAgB,EAAE,wDAAwD;AAC5E;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;IACb,cAAc;MACZ,uBAAuB;AAC7B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;IACvB,eAAe,EAAE,8CAA8C;EACjE;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA,0BAA0B;AAC1B;EACE;IACE,eAAe;MACb,cAAc;MACd,iBAAiB;EACrB;EACA;IACE,aAAa;IACb,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;;KAEG;EACH;IACE,mBAAmB;IACnB,aAAa;IACb,oCAAoC;EACtC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;;;IAGE;MACE,UAAU;IACZ;EACF;AACF;AACA;EACE;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF;AACA;EACE;IACE,aAAa,EAAE,uCAAuC;EACxD;AACF","sourcesContent":[".todonav {\n  font-weight: 600;\n  border: none;\n  gap: 30px;\n  width: auto;\n  padding: 2px 30px;\n  font-size: 19px;\n}\n.input-container {\n  position: relative;\n  display: inline-block;\n}\n.due-date-input {\n  position: relative;\n  /* z-index: 2  */\n}\n#scrollableDiv {\n  height: 400px;\n  overflow: auto;\n}\n.modalcontent-width {\n  position: relative;\n  background-color: white;\n  /* padding: 20px 5px 20px 5px !important; */\n  padding: 20px;\n  height: auto;\n  width: 500px;\n  border-radius: 10px;\n  text-align: center;\n  margin: 15% auto;\n  border: 1px solid #888;\n}\n\n.input-container .form-control {\n  padding-right: 30px; /* Adjust the padding to leave space for the icon */\n  background: url(\"https://beta.doneapp.ai/build/assets/date-3aba8fa1.png\")\n    no-repeat right center;\n  background-size: 20px 20px; /* Adjust the size of the icon */\n  font-size: 15px;\n}\n.dateicon {\n  position: absolute;\n  right: 80px; /* Adjust the position of the icon */\n  top: 50%;\n  transform: translateY(-50%);\n}\n.date-width {\n  /* width:255px; */\n  background-color: #ffff;\n  border: solid 1px #dee2e6;\n  border-radius: 7px;\n}\n.dateicon img {\n  width: 21px;\n}\n.custm-radio {\n  border-radius: 50% !important;\n  background-color: #fff;\n  border: 3px solid #009933 !important;\n  padding: 10px;\n}\n.form-check-input:checked {\n  border-color: none;\n  outline: none;\n}\n.form-check-input:focus {\n  border-color: none;\n}\n.posticon {\n  text-align: justify;\n  padding-left: 5px;\n  line-height: 20px;\n}\n.doneheading {\n  gap: 5px;\n  align-items: start;\n}\n.tdata {\n  overflow: hidden;\n  border-top: 0 !important;\n  border-right: 0 !important;\n  border-left: 0 !important;\n}\n.createdAt {\n  font-size: 10px;\n  padding-left: 5px;\n  float: left !important;\n}\n/* button.accordion-button {\n  margin-left: 20px;\n} */\n/* .nav-link.active{\n  color:#009933 !important\n} */\n\n.taskborder {\n  border-bottom: 1px solid #8080807d;\n  /* padding: 5px; */\n}\n.taskborder textarea {\n  max-height: 30px;\n  resize: none;\n  max-width: 70%;\n}\n.due-colour {\n  color: rgba(33, 37, 41, 0.75) !important;\n}\n.taskborder1 textarea {\n  max-height: 100px;\n  resize: none;\n}\n.videpart {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.taskbtn img {\n  width: 10px;\n  vertical-align: baseline;\n  margin-right: 4px;\n}\n.taskbtn {\n  color: #7c7a7acf;\n  font-family: Goldplay-bold;\n}\na {\n  text-decoration: none;\n}\n.submitclass img {\n  width: 35px;\n}\n.add-input {\n  background: none;\n  font-size: 14px !important;\n}\n.videpart input {\n  font-size: 18px;\n}\n.side-bar .menu .item a {\n  display: block;\n  color: #1a1a1a;\n}\n.side-bar .menu .item .sub-menu a {\n  padding: 3px 0 8px;\n}\n.inner-accordian {\n  padding-top: 15px;\n}\n.sub-btn {\n  color: #1a1a1a;\n  gap: 18px;\n  justify-content: center;\n  align-items: center;\n}\n.accordian-outer-button {\n  color: #1a1a1a !important;\n}\n.listoption {\n  background-color: #f7f7f7;\n  padding: 20px 30px;\n  border-radius: 12px;\n}\n.list-group-item {\n  background: none !important;\n  border: none;\n}\n.listoption {\n  font-weight: bolder;\n  color: gray;\n  font-size: 19px;\n  padding: 10px, 30px;\n}\n.rightgrey {\n  width: 13px;\n  vertical-align: initial;\n}\n.binclass {\n  font-size: 17px;\n  color: gray;\n}\n.accordian-text {\n  color: gray;\n}\n.greysearchimg {\n  background-color: #f1f1f3;\n  border-radius: 26px;\n  border-color: transparent;\n}\n.searchtodo {\n  background-color: #f1f1f3;\n  border-radius: 20px;\n}\n.mainpost-acrdn.accordion-button {\n  background-color: white !important;\n}\n\n.scrollableMain {\n  overflow-y: auto;\n  height: calc(75vh - 145px);\n  overflow-x: hidden;\n  /* Customize scrollbar track */\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  /* Customize scrollbar thumb (the draggable handle) */\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; /* Color of the thumb */\n    border-radius: 5px; /* Rounded corners */\n  }\n\n  /* Customize scrollbar track when hovered */\n  &::-webkit-scrollbar-track:hover {\n    background-color: #f0f0f0; /* Change color on hover */\n  }\n\n  /* Customize scrollbar thumb when hovered */\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555; /* Change thumb color on hover */\n  }\n}\n\n.scrollableMainDone {\n  overflow-y: auto;\n  height: calc(82vh - 145px);\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  /* Customize scrollbar thumb (the draggable handle) */\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; /* Color of the thumb */\n    border-radius: 5px; /* Rounded corners */\n  }\n\n  /* Customize scrollbar track when hovered */\n  &::-webkit-scrollbar-track:hover {\n    background-color: #f0f0f0; /* Change color on hover */\n  }\n\n  /* Customize scrollbar thumb when hovered */\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555; /* Change thumb color on hover */\n  }\n}\n.scrollableMainDelete {\n  overflow-y: auto;\n  height: calc(82vh - 145px);\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n  }\n\n  /* Customize scrollbar thumb (the draggable handle) */\n  &::-webkit-scrollbar-thumb {\n    background-color: #888; /* Color of the thumb */\n    border-radius: 5px; /* Rounded corners */\n  }\n\n  /* Customize scrollbar track when hovered */\n  &::-webkit-scrollbar-track:hover {\n    background-color: #f0f0f0; /* Change color on hover */\n  }\n\n  /* Customize scrollbar thumb when hovered */\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #555; /* Change thumb color on hover */\n  }\n}\n\n.edit-input {\n  height: 32px;\n  font-size: 32px;\n}\n.edit-input1 {\n  height: 32px;\n  font-size: 13px;\n  width: 50%;\n}\n.sub-task {\n  outline: none;\n  width: 100%;\n}\n.list-style {\n  list-style-type: disc;\n  padding-left: 5px;\n  margin-left: 100px;\n}\n.custom-file-upload {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.custom-file-input {\n  position: absolute;\n  font-size: 100px;\n  right: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.loading-gif {\n  width: 50px;\n  /* Adjust the width of your loading GIF */\n  height: 50px;\n  /* Adjust the height of your loading GIF */\n}\n.updated-at {\n  font-size: 11px;\n  line-height: 12px;\n  color: #212529;\n}\n\n.text-padding {\n  padding: 32px;\n}\n.main-posts {\n  color: rgb(33, 37, 41);\n  opacity: 1;\n}\n.form-check-input:checked[type=\"radio\"] {\n  --bs-form-check-bg-image: url(\"../../images/tick.jpg\");\n}\n.form-check-input[type=\"radio\"] {\n  border-radius: 50%;\n  border: solid 3px #009933;\n}\n.hidden-popup {\n  visibility: hidden;\n}\n\n.text-area {\n  font-size: 13px;\n  color: #212529;\n  background-color: #ffff;\n  padding: 0.375rem 0.75rem;\n  width: 638px !important;\n  height: 92px;\n  border: solid 2px #dee2e6;\n}\n.heighttodo {\n  height: 45vh;\n  overflow-x: hidden;\n  position: relative;\n}\n\n.accordion-headers {\n  background-color: #ffff;\n}\n.Addtask {\n  padding: 10px 10px 5px;\n}\n\n.videpart input {\n  font-size: 16px;\n}\n.addtaskpart {\n  border: 1px solid #cdcdcd;\n  border-radius: 8px;\n  padding: 2px 20px 0px;\n  position: \"fixed\";\n  top: 0;\n  right: 0;\n}\n.minitodo-checkbox {\n  width: 16px;\n  height: 16px;\n}\n.accordian-sort {\n  background-color: #ebe2e200;\n}\n.custm-checkbox:checked {\n  background-color: #093 !important;\n}\n.indexnum {\n  width: 4%;\n  font-size: 14px;\n}\n.custm-checkbox {\n  width: 24px;\n  height: 24px;\n  border-radius: 50% !important;\n  border: solid 3px #009933 !important;\n}\n.text-mute {\n  vertical-align: middle;\n  color: rgb(164 168 174 / 75%) !important;\n}\n.mainPostFont {\n  font-size: 13px;\n  color: #4a4a4a;\n  font-weight: 400;\n}\n.font-break {\n  word-break: break-all;\n}\n.upload-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  /* background-color: #009933; */\n  color: #ffff;\n  padding: 10px;\n  border-radius: 8px;\n  /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); */\n  width: 20%;\n  height: auto;\n}\n.upload-img-video{\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #efefef;\n  padding: 0px;\n  border-radius: 25px;\n  width:12%;\n  height: auto;\n}\n.uploadloader-img{\n  width: 100%;\n}\n.submit-upload{\n  width: 44%;\n  border-radius: 25%;\n}\n.upload-popup p {\n  font-size: 16px;\n  color: #333;\n  margin-bottom: 8px;\n}\n.progress-bar {\n  width: 100%;\n  height: 10px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress {\n  background-color: #007bff;\n  height: 100%;\n  transition: width 0.3s ease;\n}\n.edit-form textarea {\n  height: 28px;\n}\n.notes {\n  position: relative;\n  right: 2%;\n}\n.icons {\n  display: flex;\n  justify-content: space-between;\n}\n.custom-infinite {\n  overflow: hidden !important;\n}\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n/* Modal content */\n/* .modal-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 500px;\n  max-width: 90%;\n  position: relative;\n  z-index: 1001;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);\n} */\n\n/* Reply input */\n.modal-header {\n  overflow-y: auto; /* Allow vertical scrolling if the content is too long */\n}\n\n.modal-title {\n  flex: 1; /* Allow title to take up the remaining space */\n  white-space: normal; /* Allow text wrapping */\n  word-wrap: break-word; /* Ensure long words wrap correctly */\n  max-height: 100px; /* Optional: Limit title height to prevent it from taking too much space */\n  overflow-y: auto; /* Enable vertical scrolling if content exceeds height */\n}\n\n.custom-checkbox {\n  width: 17px;\n  height: 17px;\n}\n\n.urgent-post{\n  color: red;\n}\n\n.red-color{\n  color: red;\n  font-size: small;\n}\n.headerModal-text {\n  max-width: 400px;\n  font-size: 15px;\n}\n.mainReplyPostFont {\n  font-size: 13px;\n  padding: 0px !important;\n  font-weight: 400;\n  color: #003319;\n}\n.replypadding {\n  font-size: 10px;\n  padding-left: 38px;\n}\n.reply-input {\n  width: 100%;\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n/* Save button */\n.save-button {\n  margin-top: 10px;\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.save-button:hover {\n  background-color: #218838;\n}\n\n/* Close button */\n.btn-close {\n  /* background: none; */\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n.text-resize {\n  resize: none;\n}\n.complete {\n  text-decoration: line-through;\n}\n.icons-m{\n  width: 100%;\n}\n.button-icon-main{\n  font-size: 17px;\n    color: #9b9b9b;\n      /* padding-left: 5px; */\n}\n.mainpost-icons{\n  display: flex;\n  gap: 8px;\n}\n.main-imgupload{\n  width: 30px;\n  height: 23px;\n}\n@media screen and (max-width: 1024px) {\n  .custom-text {\n    padding-left: 8px !important;\n  }\n  .custom-text1 {\n    padding-left: 10px !important;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 992px) {\n  .icon-padding {\n    padding: 0px !important;\n  }\n  .mainPostFont {\n    font-size: 14px;\n  }\n}\n@media screen and (min-width: 992px) and (max-width: 1400px) {\n  .icons {\n    padding: 0px;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .mobile_height {\n    height: 90px !important;\n    font-size: 12px; /* Set the desired height for mobile screens */\n  }\n}\n\n@media screen and (max-width: 433px) {\n  .nav {\n    --bs-nav-link-padding-x: 0;\n    font-size: 16px !important;\n    padding-bottom: 8px !important;\n  }\n  .icon-padding {\n    padding: 0px;\n  }\n}\n@media screen and (max-width: 576px) {\n  .mobile_height {\n    height: 42px !important;\n  }\n  .main-imgupload{\n    width: 20px;\n    height: 20px;\n  }\n  .submitclass img {\n    width: 25px;\n    height: 25px;\n  }\n.date-mainpost {\nfont-size: 12px !important;\n}\n  .button-icon-main{\n    font-size: 18px;\n      color: #9b9b9b;\n      padding-left: 0px;\n  }\n  .mainpost-icons{\n    display: flex;\n    gap: 8px;\n  }\n  .created-duedate{\n    text-align: start;\n    margin-right: auto;\n  }\n  .createdAt {\n    float: unset !important;\n    padding-left: 0px;\n  }\n  .by-name{\n    text-align:start;\n  }\n  .modalcontent-width {\n    padding: 20px 5px 20px 5px !important;\n    width: 90%;\n  }\n\n  .due-date-input {\n    padding: 3px 0px 0px 0px;\n  }\n  .icons {\n    padding: 0px;\n    margin-left: 115px;\n    justify-content: space-evenly;\n    /* margin: auto ; */\n  }\n  .image-preview-container {\n    padding: 0px !important;\n  }\n  .mainPostFont {\n    font-size: 12px;\n  }\n  .main-postp {\n    padding-right: 0px;\n  }\n  /* .todo-paddingr {\n    padding-right: 0px;\n  } */\n  .todonav {\n    gap: 0px !important;\n    display: flex;\n    /* justify-content: space-between; */\n  }\n  .nav {\n    padding-bottom: 8px !important;\n  }\n  .sort-hide {\n    display: none;\n  }\n  .scrollableMain,\n  .scrollableMainDone,\n  .scrollableMainDelete {\n    &::-webkit-scrollbar {\n      width: 2px;\n    }\n  }\n}\n@media screen and (max-width: 768px) {\n  .hide-on-small-devices {\n    display: none; /* Hide the element for small devices */\n  }\n}\n@media screen and (min-width: 768px) {\n  .hide-on-large-devices {\n    display: none; /* Hide the element for small devices */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
